import type {z} from "zod";

import {EditServiceDescriptionBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {serviceDescriptionFieldLabelIds} from "../../../../../messages/service-description.messages";

export const editServiceDescriptionFormSchema = zod.object({
  text: requiredStringSchema(
    EditServiceDescriptionBody.shape.text,
    serviceDescriptionFieldLabelIds.text,
  ),
});
export type EditServiceDescriptionFormPayload = z.output<typeof editServiceDescriptionFormSchema>;

export const draftEditServiceDescriptionFormSchema = editServiceDescriptionFormSchema.partial();
export type DraftEditServiceDescriptionFormPayload = z.output<
  typeof draftEditServiceDescriptionFormSchema
>;
